(function () {
	'use strict';

	angular
		.module('invesfleet')
		.factory('userService', user);

	user.$inject = ['$http', '$q', 'endPoints', 'authorization', '$rootScope'];

	function user($http, $q, endPoints, authorization, $rootScope) {

		var defaultConfig = {
			colors: {
				estados: {
					null: 'grey',
					0: 'green',
					1: 'orange',
					2: 'blue',
					3: 'burdeos',
					4: 'red',
					5: 'yellow',
					6: 'violet',
					10: 'black'
				}
			},
			literals: {
				estadosOrden: {
					null: 'NU',
					/* Nueva */
					0: 'PA',
					/* Pte. Asignar */
					1: 'AS',
					/* Asignado */
					2: 'AC',
					/* Aceptado */
					3: 'RZ',
					/* Rechazado */
					4: 'IC',
					/* Iniciado */
					5: 'LZ',
					/* Localizado */
					6: 'EN',
					/* Entregado */
					10: 'FZ',
					/* Finalizado */
					11: 'OC',
					/* Ocupado */
					12: 'DC' /* Desconectado */
				},
				estados: {
					0: 'Pte. Asignar',
					1: 'Asignado',
					2: 'Aceptado',
					3: 'Rechazado',
					4: 'Iniciado',
					5: 'Localizado',
					6: 'Entregado',
					10: 'Finalizado',
					11: 'Ocupado',
					12: 'Desconectado',
				}
			},
			orders: {
				iconoOrden: {
					D: 'icon-010',
					B: 'icon-092',
					P: 'icon-056',
					T: 'icon-086',
					C: 'icon-137',
				},
				textoOrden: {
					D: 'en dirección',
					B: 'en base',
					P: 'en parking',
					T: 'en taller',
					C: 'en Colaborador'
				}
			},
			brands: {
				insurance: {
					0: 'content/img/aseguradoras/asitur/asitur-imagotipo.png',
					1: 'content/img/aseguradoras/racc/racc-imagotipo.png',
					2: 'content/img/aseguradoras/mapfre/mapfre-imagotipo.png',
					3: 'content/img/aseguradoras/europ/europ-imagotipo.png',
					4: 'content/img/aseguradoras/mm/mm-imagotipo.png',
					5: 'content/img/aseguradoras/race/race-imagotipo.png',
					6: 'content/img/aseguradoras/allianz/allianz-imagotipo.png',
					7: 'content/img/aseguradoras/pelayo/pelayo-imagotipo.png',
					8: 'content/img/aseguradoras/ld/ld-imagotipo.png',
				}
			}
		};

		var service = {
			getUserData: getUserData,
			getUser: getUser,
			getAllUsersData: getAllUsersData,
			getUsuariosRoles: getUsuariosRoles,
			getListDadosDeBaja: getListDadosDeBaja,
			storeUserData: storeUserData,
			loadWithDefaults: loadWithDefaults,
			getUserCustomInfo: getUserCustomInfo,
			deleteById: deleteById,
			saveConfig: saveConfig,
			saveColumnConfig: saveColumnConfig,
			saveFilterConfig: saveFilterConfig,
			getColumnConfig: getColumnConfig,
			getFilterConfig: getFilterConfig,
			add: add,
			userData: null
		};

		return service;

		function getUserData() {
			var deferred = $q.defer();
			var request = {
				method: 'GET',
				url: endPoints.preferences.getUserPrefs
			};

			//try

			authorization.setBearerHeader($http);
			$http(request).then(function (response) {
					service.userData = response.data;
					// console.log(response.data); 
					// console.log(service.userData);
					// $rootScope.restrictionService.getEntidadesPersonalized();
					//$rootScope.restrictionService.setLectura();
					//console.log($rootScope.restrictionService.lectura.includes('color') == false);
					deferred.resolve(response.data);
				},
				function (response) {
					service.userData = null;
					deferred.reject(null);
				});
			return deferred.promise;
		}

		function getUser(userid) {
			var deferred = $q.defer();
			var request = {
				method: 'GET',
				url: endPoints.user.getUser + '?usuarioid=' + userid
			};
			authorization.setBearerHeader($http);
			$http(request).then(function (response) {
					deferred.resolve(response.data);
				},
				function (response) {
					deferred.reject(null);
				});
			return deferred.promise;
		}



		function getUserCustomInfo(userid) {
			var deferred = $q.defer();
			var request = {
				method: 'GET',
				url: endPoints.user.getUserCustomInfo + '?usuarioid=' + userid
			};
			authorization.setBearerHeader($http);
			$http(request).then(function (response) {
					deferred.resolve(response.data);
				},
				function (response) {
					deferred.reject(null);
				});
			return deferred.promise;
		}


		function getUsuariosRoles(userid) {
			var deferred = $q.defer();
			var request = {
				method: 'GET',
				url: endPoints.user.getUsuariosRoles + '?usuarioid=' + userid
			};
			authorization.setBearerHeader($http);
			$http(request).then(function (response) {
					deferred.resolve(response.data);
				},
				function (response) {
					deferred.reject(null);
				});
			return deferred.promise;
		}

		function getAllUsersData() {
			var deferred = $q.defer();
			var request = {
				method: 'GET',
				url: endPoints.user.getAllUsers
			};
			authorization.setBearerHeader($http);
			$http(request).then(function (response) {
					deferred.resolve(response);
				},
				function (response) {
					deferred.reject(null);
				});
			return deferred.promise;
		}


		function getListDadosDeBaja(sorting, filters) {
			var deferred = $q.defer();
			var request = {
				method: 'GET',
				url: endPoints.user.getAllUsuariosDadosDeBaja,
				data: {
					sorting: sorting,
					filters: filters
				}
			};
			authorization.setBearerHeader($http);
			$http(request).then(function (response) {
					deferred.resolve(response);
				},
				function (response) {
					deferred.reject(null);
				});
			return deferred.promise;
		}

		function deleteById(usuarioid) {
			var deferred = $q.defer();
			var request = {
				method: 'POST',
				url: endPoints.user.deleteById + '?usuarioid=' + usuarioid
			};
			authorization.setBearerHeader($http);
			$http(request).then(function (response) {
					deferred.resolve(response);
				},
				function (response) {
					deferred.reject(null);
				});
			return deferred.promise;

		}

		function storeUserData(user) {
			var deferred = $q.defer();
			var request = {
				method: 'POST',
				url: endPoints.user.storeUserData,
				data: user

				//data: { perfilFlotaAdd: perfilesDeFlotaListAdd, 
				// perfilFlotaDelete: perfilesDeFlotaListDelete, user: user}
			};
			authorization.setBearerHeader($http);
			$http(request).then(function (response) {
					deferred.resolve(response.data);
				},
				function (response) {
					deferred.reject(null);
				});
			return deferred.promise;
		}

		function loadWithDefaults(defaults) {
			if (!defaults) {
				defaults = defaultConfig;
			}
			return service.getUserData()
				.then(function (data) {
					injectDefaults(defaults, data);
					return data;
				});
		}

		function saveFilterConfig(filterConfig, pageName) {
			service.userData = service.userData || {};
			service.userData.config = service.userData.config || {};
			service.userData.config.filters = service.userData.config.filters || {};
			service.userData.config.filters[pageName] = filterConfig;
			saveConfig(service.userData.config);
		}

		function getFilterConfig(pageName) {
			return service.userData && service.userData.config &&
				service.userData.config.filters && service.userData.config.filters[pageName];
		}

		function add(objs) {
			var deferred = $q.defer();
			var request = {
				method: 'POST',
				url: endPoints.user.add,
				data: objs
			};
			authorization.setBearerHeader($http);
			$http(request).then(function (response) {
					deferred.resolve(response.data);
				},
				function (response) {
					deferred.reject(null);
				});
			return deferred.promise;
		}

		function saveColumnConfig(columnConfig, pageName) {
			service.userData = service.userData || {};
			service.userData.config = service.userData.config || {};
			service.userData.config.columns = service.userData.config.columns || {};
			service.userData.config.columns[pageName] = columnConfig;
			saveConfig(service.userData.config);
		}

		function getColumnConfig(pageName) {
			return service.userData && service.userData.config &&
				service.userData.config.columns && service.userData.config.columns[pageName];
		}

		function saveConfig(config) {
			var deferred = $q.defer();
			var request = {
				method: 'POST',
				url: endPoints.user.saveConfig,
				data: angular.fromJson(config)
			};
			authorization.setBearerHeader($http);
			$http(request).then(function (response) {
					deferred.resolve(response.data);
				},
				function (response) {
					deferred.reject(null);
				});
			return deferred.promise;
		}

		function injectDefaults(src, dest) {
			for (var prop in src) {
				if (src.hasOwnProperty(prop)) {
					if (dest.hasOwnProperty(prop)) {
						if (typeof dest[prop] === 'object') {
							injectDefaults(src[prop], dest[prop]);
						}
					} else {
						dest[prop] = src[prop];
					}
				}
			}
		}

	}
})();